import OBase from './OBase';

import * as Geometry from '../geometry';

export default class LargerThan extends OBase {
  update () {
    var aValTree = this.getFloatInput('First Number');
    var bValTree = this.getFloatInput('Second Number');

    var pOutput1 = this.getGenericObjectOutput('Larger than');
    var pOutput2 = this.getGenericObjectOutput('… or Equal to');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree, bValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree1 = new Geometry.DataTree();
    var outTree2 = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {

      if(outDataTrees[0].branches[i].length == 0 || outDataTrees[1].branches[i].length == 0){
        let path = outDataTrees[0].paths[i];
        outTree1.addEmpty(path);
        outTree2.addEmpty(path);
        continue;
      }

      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var aVal = outDataTrees[0].branches[i][j];
        var bVal = outDataTrees[1].branches[i][j];

        let val1 = false;
        let val2 = false;
        if (aVal > bVal) {
          val1 = true;
        }
        if (aVal >= bVal) {
          val2 = true;
        }

        outTree1.add(val1, outDataTrees[0].paths[i]);
        outTree2.add(val2, outDataTrees[0].paths[i]);
      }
    }

    pOutput1.value = outTree1;
    pOutput2.value = outTree2;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/LargerThan.js